import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PaymentMethod} from '@gatewee/types/payment';

@Pipe({
  name: 'paymentMethod',
  pure: false,
  standalone: false,
})
export class PaymentMethodPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(
    value: PaymentMethod | Record<string, boolean> | string | undefined,
  ): string {
    if (!value) {
      return this.translate.instant('enums.paymentMethod.unknown');
    }

    if (typeof value === 'string') {
      return (
        this.translate.instant(`enums.paymentMethod.${value}`) ||
        this.translate.instant('enums.paymentMethod.unknown')
      );
    }

    if (typeof value === 'object') {
      const actives = Object.entries(value)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_, v]) => v === true)
        .map(([k]) => this.translate.instant(`enums.paymentMethod.${k}`));

      return actives.length > 0
        ? actives.join(', ')
        : this.translate.instant('enums.paymentMethod.unknown');
    }

    return this.translate.instant('enums.paymentMethod.unknown');
  }
}
